import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Trophy } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ClubPointsButton = ({ booking, customer, token, onSaved }) => {
  const [busy, setBusy] = useState(false);
  const who = booking?.name || customer?.name || "this customer";
  const id = booking?.id || customer?.email;

  const send = async () => {
    if (!window.confirm(`Send ${who} their Drivers Club points summary by SMS + email?${booking ? " It highlights the points earned on this rental." : ""}`)) return;
    setBusy(true);
    try {
      const payload = booking ? { booking_id: booking.id } : { email: customer?.email || "", phone: customer?.phone || "" };
      const { data } = await axios.post(`${API}/drivers-club/points-message`, payload,
        { headers: { Authorization: `Bearer ${token}` } });
      const pts = data.rental_points != null ? `${data.rental_points.toLocaleString()} pts this rental · ` : "";
      toast.success(`Club points message sent — ${pts}balance ${data.balance.toLocaleString()} pts (${data.tier}). SMS: ${data.results.sms} · Email: ${data.results.email}`, { duration: 8000 });
      onSaved?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not send the points message."); }
    finally { setBusy(false); }
  };

  return (
    <button data-testid={`club-points-${id}`} onClick={send} disabled={busy}
      className="text-xs flex items-center gap-1.5 border border-[#F2B705]/50 text-[#F2B705] font-bold px-3 py-1.5 rounded hover:bg-[#F2B705] hover:text-black transition-colors disabled:opacity-60">
      {busy ? <Loader2 className="animate-spin" size={13} /> : <Trophy size={13} />} Send Club Points
    </button>
  );
};

export default ClubPointsButton;
